import React from 'react';
import './Funding.css';

// Import funding logos
import DST_LOGO from '../assets/fundingAssets/DST LOGO.jpg';
import DAE_LOGO from '../assets/fundingAssets/DAE LOGO.jpg';
import DBT_LOGO from '../assets/fundingAssets/DBT LOGO.jpg';
import ICMRL from '../assets/fundingAssets/ICMRL.jpg';
import IITG_LOGO from '../assets/fundingAssets/iitg_logo.png';
import INSPIRE_LOGO from '../assets/fundingAssets/INSPIRE LOGO.jpg';
import UKIERI_LOGO from '../assets/fundingAssets/Ukieri LOGO.jpg';
import SPIBER_LOGO from '../assets/fundingAssets/Spiber LOGO.jpg';

const FundingAndCollaborators = () => {
  const fundingAgencies = [
    { name: 'Department of Science & Technology', logo: DST_LOGO },
    { name: 'Department of Atomic Energy - BRNS', logo: DAE_LOGO },
    { name: 'Department of Biotechnology', logo: DBT_LOGO },
    { name: 'Indian Council of Medical Research', logo: ICMRL},
    { name: 'IIT Guwahati', logo: IITG_LOGO },
    { name: 'INSPIRE - DST', logo: INSPIRE_LOGO },
    { name: 'UKIERI', logo: UKIERI_LOGO },
    { name: 'Spiber Technologies', logo: SPIBER_LOGO },
  ];

  const mentors = [
    {
      id: 1,
      name: 'Prof. David Kaplan',
      institution: 'Department of Biomedical Engineering, Tufts University',
      location: 'Boston, USA',
    },
    {
      id: 2,
      name: 'Prof. Subhas C. Kundu',
      institution: 'Department of Biotechnology, IIT Kharagpur',
      location: 'India',
    },
  ];


  return (
    <div className="funding-page_funding">
      <div className="funding-container_funding">
        {/* Page Title */}
        <h1 className="page-title_funding">Funding & Collaborations</h1>

        {/* Funding Logos */}
        <section className="section-block_funding">
          <h2 className="section-heading_funding">Funding Agencies</h2>
          <div className="logos-row_funding">
            {fundingAgencies.map((agency, index) => (
              <div key={index} className="logo-box_funding">
                <img src={agency.logo} alt={agency.name} title={agency.name} />
              </div>
            ))}
          </div>
        </section>

        {/* Mentors */}
        <section className="section-block_funding">
          <h2 className="section-heading_funding">Research Mentors</h2>
          <div className="list-grid_funding two-col_funding">
            {mentors.map((mentor) => (
              <div key={mentor.id} className="list-item_funding">
                <span className="item-name_funding">{mentor.name}</span>
                <span className="item-detail_funding">{mentor.institution}</span>
                <span className="item-location_funding">{mentor.location}</span>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default FundingAndCollaborators;